import Input, { InputProps } from "components/atoms/Input";
import { ALL_DOMAINS, POPULAR_DOMAINS } from "constants/domains";
import React, { useState, useLayoutEffect, useRef } from "react";
import { useFormContext, useWatch } from "react-hook-form";

import "./styles.sass";

const EmailInputWrapper: React.FC<InputProps> = ({ value, name, ...props }) => {
  const { setValue } = useFormContext();
  const [suggestions, setSuggestions] = useState<string[]>([]);
  const currentLogin: string = useWatch({ name });
  const previousLogin = useRef(currentLogin);

  const handleSuggestionClick = (suggestedDomain: string) => {
    const localPart = currentLogin.split("@")[0];
    const newValue = `${localPart}@${suggestedDomain}`;
    setValue(name, newValue);
    setSuggestions([]); // Clear suggestions immediately after selecting
    previousLogin.current = newValue; // Update previous login to prevent immediate rerender
  };

  useLayoutEffect(() => {
    // Avoid updating suggestions if currentLogin did not actually change
    if (currentLogin === previousLogin.current) {
      return;
    }

    if (currentLogin && currentLogin.includes("@")) {
      const [_, domainPart] = currentLogin.split("@");
      if (domainPart === "") {
        setSuggestions(ALL_DOMAINS);
      } else {
        const filteredSuggestions = ALL_DOMAINS.filter((domain) =>
          domain.startsWith(domainPart),
        ).slice(0, 3);

        setSuggestions(
          filteredSuggestions.length ? filteredSuggestions : POPULAR_DOMAINS,
        );
      }
    } else {
      setSuggestions([]);
    }
    previousLogin.current = currentLogin; // Update previous login only after processing
  }, [currentLogin]);

  return (
    <div className="EmailInputWrapper">
      <Input {...props} value={value} name={name} />
      {suggestions.length > 0 && (
        <div className="EmailInputWrapper-suggestions">
          {suggestions.map((suggestion) => (
            <div
              className="EmailInputWrapper-suggestions__item"
              key={suggestion}
              onMouseDown={(e) => e.preventDefault()} // Prevent blur on click
              onClick={() => handleSuggestionClick(suggestion)}
            >
              {`@${suggestion}`}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default EmailInputWrapper;
